export interface PPSRCheckDialogData {
  message: string;
  subMessage: string;
}

export interface PPSRCheckDialogResult {
}
